(function(){
'use strict';
function start(){
 var root=document.querySelector('[data-flatoo-b2b-page]');
 if(!root||root.dataset.trackingBound==='true')return;
 root.dataset.trackingBound='true';
 function push(event,detail){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:event,flatoo_component:'corporate_inquiry',flatoo_interaction:detail||''});}
 var form=root.querySelector('#FlatooB2BContact');
 // Safely retain the product handle in the Shopify contact email.
 // Only a public catalog handle is accepted; never pass customer data to GTM.
 if(form){
  var params=new URLSearchParams(window.location.search);
  var handle=params.get('product')||'';
  if(/^[a-z0-9-]{1,160}$/.test(handle)){
   var selected=document.createElement('input');
   selected.type='hidden';
   selected.name='contact[検討商品]';
   selected.value='https://flatoo.jp/products/'+handle;
   form.appendChild(selected);
  }
 }
 var begun=false;
 root.addEventListener('click',function(e){
  var link=e.target.closest('[data-b2b-cta]');
  if(link)push('flatoo_cvr_b2b_cta_click',link.getAttribute('data-b2b-cta'));
 });
 if(form){
  form.addEventListener('focusin',function(e){
   if(begun||!e.target.matches('input:not([type="hidden"]),textarea,select'))return;
   begun=true;push('flatoo_cvr_b2b_form_start','start');
  });
  form.addEventListener('submit',function(){
   if(form.checkValidity())push('flatoo_cvr_b2b_form_submit_attempt','submit');
  });
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
else start();
document.addEventListener('shopify:section:load',start);
})();

/* flatoo B2B contact submission status v4 - three pages */
(function(){
 'use strict';
 function setup(root){
   if(root.dataset.flatooContactUiBound==='true')return;
   root.dataset.flatooContactUiBound='true';
   var form=root.querySelector('#FlatooB2BContact');
   if(!form)return;
   var complete=form.querySelector('[data-flatoo-b2b-complete]');
   var error=form.querySelector('[role="alert"]');
   if(complete){
     root.classList.add('flatoo-b2b-has-completed');
     requestAnimationFrame(function(){
       // Success is server-rendered by Shopify; never infer it from a button click.
       complete.scrollIntoView({behavior:'auto',block:'center'});
       try{complete.focus({preventScroll:true});}catch(err){complete.focus();}
     });
     return;
   }
   if(error){
     requestAnimationFrame(function(){
       error.scrollIntoView({behavior:'auto',block:'center'});
       try{error.focus({preventScroll:true});}catch(err){}
     });
   }
   var button=form.querySelector('[data-b2b-submit]');
   var originalButton=button?button.innerHTML:'';
   var sending=false;
   var status=document.createElement('p');
   status.className='flatoo-b2b-sending-status';
   status.setAttribute('role','status');
   status.setAttribute('aria-live','polite');
   status.hidden=true;
   if(button)button.insertAdjacentElement('afterend',status);
   function restore(){
     sending=false;
     if(button){
       button.disabled=false;
       button.innerHTML=originalButton;
       button.removeAttribute('aria-disabled');
     }
     form.removeAttribute('aria-busy');
     status.hidden=true;
     status.textContent='';
   }
   form.addEventListener('submit',function(event){
     if(!form.checkValidity())return;
     if(sending){
       event.preventDefault();
       return;
     }
     sending=true;
     if(button){
       button.innerHTML='送信しています…';
       button.setAttribute('aria-disabled','true');
       // Keep browser and Shopify CAPTCHA submission handlers working.
       requestAnimationFrame(function(){button.disabled=true;});
     }
     form.setAttribute('aria-busy','true');
     status.hidden=false;
     status.textContent='送信処理中です。画面が切り替わるまで再度押さずにお待ちください。';
   });
   // A browser back-navigation or CAPTCHA return can restore the original page.
   window.addEventListener('pageshow',function(event){
     if(event.persisted)restore();
   });
 }
 function init(){document.querySelectorAll('[data-flatoo-b2b-page]').forEach(setup);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
 document.addEventListener('shopify:section:load',init);
})();
